import mutations from './mutations'
import actions from './actions'

const customers = {
    namespaced: true,
    state: {
        customers: [],
        isLoaded: false,
        activeCustomer: null,
        pagination: {
            page: 1,
            length: null,
            total: null
        },
        filters: {
            fromDate: new Date(+new Date() - 2419200000).toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0],
            email: null,
            phone: null
        }
    },
    mutations,
    actions
}

export default customers
